
function checkRechargeCancelPage() {
  const recharge_container = document.querySelector('#recharge-onsite');
  if (recharge_container) {
    console.log("init recharge container observer");
    let observer = new MutationObserver(mutationRecords => {
      console.log("les changements");
      console.log(mutationRecords); // console.log(les changements)
      if (mutationRecords?.length > 0) {
        let isCancelSubscriptionPage = false;
        for (let index = 0; index < mutationRecords.length; index++) {
          const mutationRecord = mutationRecords[index];
          if (mutationRecord.addedNodes?.length > 0 && mutationRecord.addedNodes[0].childNodes?.length > 0) {
            console.log(mutationRecord.addedNodes[0]);
            const foundItem = mutationRecord.addedNodes[0].querySelector('#custom_recharge_cancel');
            if (foundItem) {
              isCancelSubscriptionPage = true;
            }
          }
        }
        if (isCancelSubscriptionPage) {
          launchRechargeCancelPage();
        }
      }
    });

    // const recharge_theme_containers = document.querySelectorAll('.recharge-theme');
    // if (recharge_theme_containers?.length > 0) {
    //   for (let index = 0; index < recharge_theme_containers.length; index++) {
    //     const inputElement = recharge_theme_containers[index];
    //     // observer tout sauf les attributs
    //     observer.observe(inputElement, {
    //       childList: true, // observer les enfants directs
    //       subtree: true
    //     });
    //   }
    // }

    const body_container = document.querySelector('body');

    // observer tout sauf les attributs
    observer.observe(body_container, {
      childList: true, // observer les enfants directs
      subtree: true
    });
  } else {
    console.log("recharge container not found");
  }
}

checkRechargeCancelPage();


function launchRechargeCancelPage() {
  const itemDiaperTry = document.querySelector('#custom_recharge_cancel_diaper_try_48');
  const itemAccordeonSurvey = document.querySelector('#custom_recharge_accordeon_survey');
  const itemAfterSurvey = document.querySelector('#custom_recharge_after_survey');
  if (itemDiaperTry) {
    initDiaperTry();
  }
  if (itemAccordeonSurvey) {
    initSurvey();
  }
  if (itemAfterSurvey) {
    initAfterSurvey();
  }
}

function initDiaperTry() {

  const splitUrl = window.location.href.split('/');
  const getIndex = splitUrl.indexOf('subscriptions');
  const getToken = splitUrl[getIndex - 1];
  const subId = splitUrl[getIndex + 1];
  fetchSubscriptionDiaperTry(getToken, subId);
  updateActionButtonForDiaperTry();
}

function initSurvey() {
  const firstSurvey = document.querySelector('div.main-accordion');
  if (firstSurvey) {
    const secondSurvey = document.querySelector('div[data-testid="churn-retention-survey"]');
    if (secondSurvey) {
      const currentSurveyBtn = document.querySelector('button[data-testid="survey-submit-button"]');
      if (currentSurveyBtn) {
        currentSurveyBtn.classList.add('hidden');
      }
      const inputs = secondSurvey.querySelectorAll('input[type="radio"]');
      if (inputs?.length > 0) {
        for (let index = 0; index < inputs.length; index++) {
          const inputElement = inputs[index];
          inputElement.addEventListener('click', (event) => {
            const currentSurveyBtn = document.querySelector('button[data-testid="survey-submit-button"]');
            if (currentSurveyBtn) {
              currentSurveyBtn.classList.remove('hidden');
            }
          })
        }
      }
      firstSurvey.style.display = "";
      secondSurvey.style.display = "none";
      firstSurvey.querySelectorAll('button.accordion-button').forEach((accButton) =>
        accButton.addEventListener('click', (event) => {
          this.expandFirstSurveyStep(event.currentTarget);
        })
      );
    }
  }
}

function initAfterSurvey() {
  const splitUrl = window.location.href.split('/');
  const getIndex = splitUrl.indexOf('subscriptions');
  const subId = splitUrl[getIndex + 1];

  if (subId) {
    const currentSubscriptionLink = document.querySelector('a[data-lmem-override="subscription"]');
    if (currentSubscriptionLink) {
      currentSubscriptionLink.href = `${BASE_MEMBER_WEBSITE_URL}/account/subscription/${subId}`;
    }
  }

}

function expandFirstSurveyStep(firstSurveyStepElement) {
  document.querySelectorAll('button.accordion-button').forEach((accButton) => {
    accButton.classList.remove("active");
  });
  firstSurveyStepElement.classList.toggle("active");
  var panel = firstSurveyStepElement.nextElementSibling;
  this.hideSecondSurveyItems(firstSurveyStepElement);
  const secondSurvey = document.querySelector('div[data-testid="churn-retention-survey"]');
  secondSurvey.style.display = "";
  panel.appendChild(secondSurvey);
}

function hideSecondSurveyItems(firstSurveyStepElement) {
  console.log(firstSurveyStepElement);
  const secondSurvey = document.querySelector('div[data-testid="churn-retention-survey"]')
  if (secondSurvey) {
    const inputs = secondSurvey.querySelectorAll('input[type="radio"]');
    console.log(inputs);
    if (inputs?.length > 0) {
      let displayItems = [];
      if (firstSurveyStepElement) {
        const targetAttribute = firstSurveyStepElement.getAttribute("data-reasons");
        if (targetAttribute) {
          const arrayReasons = targetAttribute.split(';');
          if (arrayReasons?.length > 0) {
            displayItems = arrayReasons;
          }
        }
      }

      for (let index = 0; index < inputs.length; index++) {
        const inputElement = inputs[index];
        console.log(inputElement);

        if (displayItems.includes(inputElement.value)) {
          inputElement.closest('div[data-testid="form-option"]').parentNode.style.display = "";
        } else {
          inputElement.closest('div[data-testid="form-option"]').parentNode.style.display = "none";
        }
      }
    }
  }
}

// const baseApiUrl = 'https://api.staging.membre.lamarqueenmoins.fr';
// const baseApiToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyTmFtZSI6IkNoZWNrb3V0VmFsaWRhdGlvbiJ9.F8MaG40K-4vQn9K7smsfjpgi3SvIGzYmQf-WFSUoNJI';


async function fetchSubscriptionDiaperTry(customerHash, subId) {
  try {
    const response = fetch(`${BASE_MEMBER_API_URL}/shop/subscription/cancelling?hash=${customerHash}&subscriptionId=${subId}`, {
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${BASE_MEMBER_API_TOKEN}`, // notice the Bearer before your token,
        'AppVersion-Header': 'web'
      }
    })
      .then(res => res.json())
      .then(data => {
        const count = data.result;
        replaceData(count);
      })

  } catch (error) {
    console.error('Error fetching subscriber count:', error);
  }
}

async function replaceData(jsonResult) {
  try {
    if (jsonResult.customerFirstName) {
      const customerFirstNameContainers = document.querySelectorAll('div[data-lmem-override="firstname"]');
      if (customerFirstNameContainers?.length > 0) {
        customerFirstNameContainers.forEach(c => {
          c.textContent = jsonResult.customerFirstName;
        })
      }
    }
    if (jsonResult.childDescription) {
      const childFirstNameContainers = document.querySelectorAll('div[data-lmem-override="child"]');
      if (childFirstNameContainers?.length > 0) {
        childFirstNameContainers.forEach(c => {
          c.textContent = jsonResult.childDescription;
        })
      }
    }
    if (jsonResult.deliveryDate) {
      const deliverydateContainers = document.querySelectorAll('div[data-lmem-override="deliverydate"]');
      if (deliverydateContainers?.length > 0) {
        deliverydateContainers.forEach(c => {
          c.textContent = jsonResult.deliveryDate;
        })
      }
    }
    if (jsonResult.originalProductImageUrl) {
      const productImgs = document.querySelectorAll('img[data-lmem-override="originalproduct"]');
      if (productImgs?.length > 0) {
        productImgs.forEach(c => {
          c.src = jsonResult.originalProductImageUrl;
        })
      }
    }
    if (jsonResult.nextChargeEmailReminderDate) {
      const nextChargeEmailReminderDateContainers = document.querySelectorAll('div[data-lmem-override="email"]');
      if (nextChargeEmailReminderDateContainers?.length > 0) {
        nextChargeEmailReminderDateContainers.forEach(c => {
          c.textContent = jsonResult.nextChargeEmailReminderDate;
        })
      }
    }
    if (jsonResult.nextChargeWhatsappReminderDate) {
      const nextChargeWhatsappReminderDateContainers = document.querySelectorAll('div[data-lmem-override="whatsapp"]');
      if (nextChargeWhatsappReminderDateContainers?.length > 0) {
        nextChargeWhatsappReminderDateContainers.forEach(c => {
          c.textContent = jsonResult.nextChargeWhatsappReminderDate;
        })
      }
    }
    if (jsonResult.nextChargeShippingDate) {
      const nextChargeShippingDateContainers = document.querySelectorAll('div[data-lmem-override="shipping"]');
      if (nextChargeShippingDateContainers?.length > 0) {
        nextChargeShippingDateContainers.forEach(c => {
          c.textContent = jsonResult.nextChargeShippingDate;
        })
      }
      const nextChargeShippingDateLongContainers = document.querySelectorAll('div[data-lmem-override="nextshipping"]');
      if (nextChargeShippingDateLongContainers?.length > 0) {
        nextChargeShippingDateLongContainers.forEach(c => {
          c.textContent = `Expédition prévue le ${jsonResult.nextChargeShippingDate}`;
        })
      }
    }
    if (jsonResult.currentProductImageUrl) {
      const currentProductImgs = document.querySelectorAll('img[data-lmem-override="currentproduct"]');
      if (currentProductImgs?.length > 0) {
        currentProductImgs.forEach(c => {
          c.src = jsonResult.currentProductImageUrl;
        })
      }
    }
    if (jsonResult.giftSection?.items?.length > 0) {
      const mainGiftSection = document.querySelector('div.main-gift');
      if (mainGiftSection) {
        if (jsonResult.giftSection.mainTitle) {
          const divTitle = document.createElement("div");
          divTitle.classList = "styletitle";
          divTitle.innerHTML = jsonResult.giftSection.mainTitle;
          mainGiftSection.appendChild(divTitle);
        }
        if (jsonResult.giftSection.mainDescription) {
          const divTitle = document.createElement("div");
          divTitle.innerHTML = jsonResult.giftSection.mainDescription;
          mainGiftSection.appendChild(divTitle);
        }

        if (jsonResult.giftSection.items?.length > 0) {
          for (let index = 0; index < jsonResult.giftSection.items.length; index++) {
            const item = jsonResult.giftSection.items[index];
            let divBanner = document.createElement("div");
            divBanner.classList = "gift-banner";
            if (item.productImgUrl) {
              const imgBanner = document.createElement("img");
              imgBanner.src = item.productImgUrl;
              divBanner.appendChild(imgBanner);
            }
            let divColumn = document.createElement("div");
            divColumn.classList = "column";

            if (item.productTitle) {
              const divTitle = document.createElement("div");
              divTitle.classList = "gift-title";
              divTitle.innerHTML = item.productTitle;
              divColumn.appendChild(divTitle);
            }

            if (item.productQty) {
              const divTitle = document.createElement("div");
              divTitle.classList = "gift-qty";
              divTitle.innerHTML = item.productQty;
              divColumn.appendChild(divTitle);
            }
            divBanner.appendChild(divColumn);
            mainGiftSection.appendChild(divBanner);
          }
        }
        mainGiftSection.classList.remove('hidden');
      }
    }

  } catch (error) {
    console.error('Error fetching subscriber count:', error);
  }
}

function updateActionButtonForDiaperTry() {

  const currentSurvey = document.querySelector('div[data-testid="churn-retention-survey"]');
  const currentSurveyBtn = document.querySelector('button[data-testid="survey-submit-button"]');

  if (currentSurveyBtn) {
    currentSurveyBtn.classList.add('hidden');
  }

  const inputs = currentSurvey.querySelectorAll('input[type="radio"]');
  if (inputs?.length > 0) {
    for (let index = 0; index < inputs.length; index++) {
      const inputElement = inputs[index];
      inputElement.addEventListener('click', (event) => {
        const currentSurveyBtn = document.querySelector('button[data-testid="survey-submit-button"]');
        if (currentSurveyBtn) {
          currentSurveyBtn.classList.remove('hidden');
        }
      })
    }
  }

  const btnNotify = document.querySelector('button.js-notifyme');
  if (btnNotify) {
    btnNotify.addEventListener('click', (event) => {
      const divToDisplay = document.querySelectorAll('.js-display-after-alert');
      for (let index = 0; index < divToDisplay.length; index++) {
        const divToDisplayElement = divToDisplay[index];
        divToDisplayElement.classList.remove('hidden');
      }

      const divToHide = document.querySelectorAll('.js-hidden-after-alert');
      for (let index = 0; index < divToHide.length; index++) {
        const divToHideElement = divToHide[index];
        divToHideElement.classList.add('hidden');
      }
      currentSurvey.classList.add('hidden');
    })
  }
}

function copyCodeC12ToClipboard() {
  navigator.clipboard.writeText("COUCHES12");
  const tooltip = document.querySelector('.tooltip-copy');
  if (tooltip) {
    tooltip.classList.remove('hidden');
  }
}